import apiClient from './client';

export const imagine = async ({
  prompt,
  model,
  size,
  async: asyncRequest,
}) =>
  apiClient.post('/ai/imagine', {
    prompt,
    ...(model ? { model } : {}),
    ...(size ? { size } : {}),
    ...(asyncRequest !== undefined ? { async: asyncRequest } : {}),
  });

export const edit = async ({
  prompt,
  image,
  images,
  imageUrls,
  mask,
  model,
  size,
  n,
  taskType,
  historyPrompt,
  async: asyncRequest,
}) => {
  const formData = new FormData();
  formData.append('prompt', prompt);
  if (image) {
    formData.append('image', image);
  }
  if (Array.isArray(images)) {
    images.forEach((file) => {
      if (file) {
        formData.append('images', file);
      }
    });
  }
  if (Array.isArray(imageUrls) && imageUrls.length) {
    formData.append('imageUrls', JSON.stringify(imageUrls));
  }
  if (mask) {
    formData.append('mask', mask);
  }
  if (model) {
    formData.append('model', model);
  }
  if (size) {
    formData.append('size', size);
  }
  if (n) {
    formData.append('n', n);
  }
  if (taskType) {
    formData.append('taskType', taskType);
  }
  if (historyPrompt) {
    formData.append('historyPrompt', historyPrompt);
  }
  if (asyncRequest !== undefined) {
    formData.append('async', asyncRequest ? 'true' : 'false');
  }

  return apiClient.post('/ai/edit', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const describe = async ({ file }) => {
  const formData = new FormData();
  formData.append('image', file);

  return apiClient.post('/ai/describe', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const enhancePrompt = async ({
  prompt,
  model,
  size,
  taskType,
}) =>
  apiClient.post('/ai/enhance-prompt', {
    prompt,
    ...(model ? { model } : {}),
    ...(size ? { size } : {}),
    ...(taskType ? { taskType } : {}),
  });

export const fetchGenerationModels = () =>
  apiClient.get('/generation-models');

export const fetchHistory = async ({ limit, timeframe, offset, tag, search, sort } = {}) =>
  apiClient.get('/ai/history', {
    params: {
      ...(limit ? { limit } : {}),
      ...(offset ? { offset } : {}),
      ...(timeframe ? { timeframe } : {}),
      ...(tag ? { tag } : {}),
      ...(search ? { search } : {}),
      ...(sort ? { sort } : {}),
    },
  });

export const fetchHistoryTags = async ({ timeframe, search, limit } = {}) =>
  apiClient.get('/ai/history/tags', {
    params: {
      ...(timeframe ? { timeframe } : {}),
      ...(search ? { search } : {}),
      ...(limit ? { limit } : {}),
    },
  });

export const fetchHistoryEntry = async (id) =>
  apiClient.get(`/ai/history/${id}`);

export const clearHistory = async ({ timeframe, since } = {}) =>
  apiClient.request({
    method: 'delete',
    url: '/ai/history',
    data: {
      ...(timeframe ? { timeframe } : {}),
      ...(since ? { since } : {}),
    },
  });

export const deleteHistoryEntry = async (id) =>
  apiClient.delete(`/ai/history/${id}`);

export const updateHistoryTags = async (id, tags = []) =>
  apiClient.patch(`/ai/history/${id}/tags`, {
    tags,
  });

export default {
  imagine,
  edit,
  describe,
  enhancePrompt,
  fetchGenerationModels,
  fetchHistory,
  fetchHistoryTags,
  fetchHistoryEntry,
  clearHistory,
  deleteHistoryEntry,
  updateHistoryTags,
};
